import { notifyBrokerageDataChanged } from 'Components/Banking/brokerageDataBus';

// Uebernimmt den Sitzungsstatus (verbleibende comdirect-Verbindung) aus einer
// Server-Antwort in den globalen Zustand fuer die Sitzungsanzeige in der
// Top-Navigation (Chat-Modus, Umbau 2026-07-26). x.was.setBrokerageSession
// wird von NavigationTop.js gesetzt - vor dessen erstem Render (o.ae.) ist es
// noch undefined, daher der Guard.
//
// Wird an genau den Stellen aufgerufen, an denen gerade eine comdirect-
// Aktion abgeschlossen wurde (Login/TAN-Bestaetigung, Order anlegen/aendern/
// streichen, Sync-Now) - das Backend synchronisiert dabei praktisch immer
// Depot UND Orderbuch zusammen (BrokerageTask::syncBrokerageData()), daher
// hier gleich auch alle offenen Brokerage-Seiten zum Neuladen anstossen
// (Chat vom 2026-07-26, Bugreport: Depot zeigte eine woanders ausgefuehrte
// Order nicht, bis dort separat auf Reload geklickt wurde). Ein paar
// ueberfluessige Neuladungen (z.B. bei einem reinen Login ohne Sync) sind
// dabei in Kauf genommen - billiger lokaler DB-Read, kein comdirect-Zugriff.
export default function applyBrokerageSession(x, content) {
	if (content && content.brokerageSession !== undefined && x.was.setBrokerageSession) {
		x.was.setBrokerageSession(content.brokerageSession);
	}
	notifyBrokerageDataChanged(x);
}
